import { cn } from '@/utils/tailwind';

const formatter = new Intl.NumberFormat('en-US', {});

export function Rate({
  value,
  invert,
  testId,
  className,
}: {
  value: number;
  invert?: boolean;
  testId?: string;
  className?: string;
}) {
  const valueToTestColor = invert ? -value : value;
  const scale = invert ? [-0.5, -0.1, -0.01] : [0.01, 0.1, 0.5];
  let bgColor = 'bg-error-primary';
  let textColor = 'text-error';
  if (valueToTestColor <= scale[0]) {
    bgColor = 'bg-success-primary';
    textColor = 'text-success';
  } else if (valueToTestColor <= scale[1]) {
    bgColor = 'bg-warning-primary';
    textColor = 'text-warning';
  } else if (valueToTestColor <= scale[2]) {
    bgColor = 'bg-error-primary';
    textColor = 'text-error';
  }

  const percentageRoundedToNearestInt = Math.round(value * 100);
  return (
    value !== undefined && (
      <div
        className={cn(
          'inline-flex h-5 items-center justify-center rounded px-1.5',
          textColor,
          bgColor,
          className
        )}
        data-testid={testId}
      >
        <div className="text-center font-medium leading-none">
          {formatter.format(percentageRoundedToNearestInt)}%
        </div>
      </div>
    )
  );
}
